import { AIRLINE_LOGO_CODES_MAX, CARRIER_CODE_PATTERN } from "@seagames/contracts";

/**
 * The `codes=` of `GET /airlines/logos`: upper-cased, valid designators only,
 * de-duplicated, SORTED (so the same set is the same cache entry whatever the
 * order on screen), at most AIRLINE_LOGO_CODES_MAX. "" = nothing to ask.
 */
export function airlineLogoCodes(codes: ReadonlyArray<string | null | undefined>): string {
	const set = new Set<string>();
	for (const c of codes) {
		const code = (c ?? "").trim().toUpperCase();
		if (CARRIER_CODE_PATTERN.test(code)) set.add(code);
	}
	return [...set].sort().slice(0, AIRLINE_LOGO_CODES_MAX).join(",");
}

/** The code badge's tones (theme tokens), picked by the code so an airline always gets the same one. */
export const AIRLINE_BADGE_TONES = [
	"bg-gms-navy-soft text-gms-navy",
	"bg-gms-ok-soft text-gms-ok",
	"bg-gms-warn-soft text-gms-warn",
	"bg-gms-soft-2 text-gms-ink-2",
	"bg-gms-navy text-white",
] as const;

export function airlineBadgeTone(code: string): (typeof AIRLINE_BADGE_TONES)[number] {
	let h = 0;
	for (const ch of code.toUpperCase()) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
	return AIRLINE_BADGE_TONES[h % AIRLINE_BADGE_TONES.length]!;
}
